"use strict";

var ctx = require.context('./templates', true, /\.jsx?$/);

var ret = {};

ctx.keys().reduce(function (obj, key) {
    var name = key.replace(/(.*\/)?(.*)\.jsx?$/, '$2');
    if (/Bundle$/.test(name)) {
        var bundle =  ctx(key).default;
        return Object.assign(obj,bundle);
    } else {
        obj[name] = ctx(key).default;
    }
    return obj;
}, ret);


module.exports = ret;


/** WEBPACK FOOTER **
 ** ./src/templates.js
 **/